import { compact, max, min } from 'lodash'
import { debug } from 'lib/logging'

export function minDate(...args: (Date | undefined | string | null)[]): Date | undefined {
  debug(`mindate`, `mindate`, `args`, args)
  let epoch = new Date(null!).getTime()
  let ret = min(
    compact(args)
      ?.map((a) => (typeof a === `string` ? new Date(a) : a))
      .filter((a) => a && !isNaN(a.getTime()) && a.getTime() !== epoch),
  )
  debug(`leads`, `min is`, ret)
  return ret
}

export function maxDate(...args: (Date | undefined | string)[]): Date | undefined {
  debug(`mindate`, `maxDate`, `args`, args)
  let epoch = new Date(null!).getTime()
  return max(
    args
      ?.map((a) => (typeof a === `string` ? new Date(a) : a))
      .filter((a) => a && !isNaN(a.getTime()) && a.getTime() !== epoch),
  )
}
